import React from 'react';
import { Header } from 'layout';
import { withPlaceholder } from 'HOC';
import { useGetDocuments } from 'hooks/api/documents';
import ContactSupportButton from 'components/ContactSupportButton';
import messages from './Documents.messages';
import DocumentList from './DocumentList';

const DocumentListWithPlaceholder = withPlaceholder(DocumentList);

export default function Documents() {
  const {
    data: documents,
    isRefetching,
    isError,
    isLoading,
    refetch,
  } = useGetDocuments();
  const isData = !!documents && documents?.groups?.length !== 0;

  return (
    <>
      <Header title={messages.title}>
        <ContactSupportButton />
      </Header>
      <DocumentListWithPlaceholder
        isLoading={isLoading}
        isRefetching={isRefetching}
        isError={isError}
        isData={isData}
        refetch={refetch}
        documentList={documents}
      />
    </>
  );
}
